import { useEffect, useState } from 'react'

import type { PageInfo } from '../types'
import { usePageProps } from '../usePageProps'

type GamConfig = {
  pageInfo: PageInfo
  login?: {
    loginStatus: string
    transformTypeDecision?: string
  }
  includePersonalisation?: boolean
}

type PageGamProps = {
  pageInfo: PageInfo
}

export const usePageGamConfig = ({ pageInfo }: PageGamProps) => {
  const [gamConfig, setGamConfig] = useState<GamConfig>()

  const { userAccessState } = usePageProps()
  const { userLoggedIn, transformTypeDecision } = userAccessState ?? {}
  const loginStatus = userLoggedIn ? 'LoggedIn' : 'LoggedOut'

  useEffect(() => {
    setGamConfig({
      pageInfo,
      login: {
        loginStatus,
        transformTypeDecision,
      },
      includePersonalisation: true,
    })
  }, [pageInfo, loginStatus, transformTypeDecision])

  return gamConfig
}
